import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa'; // Import icons

export default function AgentsSection() {
  // Array of agents data
  const agents = [
    {
      name: "Donald Palmer",
      phone: "(756) 447 5779",
      email: "info@example.com",
      properties: 5,
      image: "/images/agent-1.webp",
    },
    {
      name: "Sean Hamilton",
      phone: "(756) 447 5779",
      email: "info@example.com",
      properties: 2,
      image: "/images/agent-2.webp",
    },
    {
      name: "Christine Gilbert",
      phone: "(756) 447 5779",
      email: "info@example.com",
      properties: 4,
      image: "/images/agent-3.webp",
    },
    {
      name: "Jason Patel",
      phone: "(756) 447 5779",
      email: "info@example.com",
      properties: 2,
      image: "/images/agent-4.webp",
    },
  ];

  // State to track hover on card
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div className="container pb-5" id={'agents'}>
      <h2 className="text-3xl font-bold text-center mb-5">Our Agents</h2>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
        {agents.map((agent, index) => (
          <motion.div
            key={index}
            className="col"
            initial={{ opacity: 0 }} // Start as invisible
            animate={{ opacity: 1 }} // Animate to visible
            transition={{ delay: index * 0.2, duration: 1 }} // Staggered delay
          >
            <motion.div
              className="card shadow border-0 position-relative"
              onMouseEnter={() => setHoveredCard(index)} // Set the card as hovered
              onMouseLeave={() => setHoveredCard(null)} // Remove hover effect when mouse leaves
            >
              <div className="overflow-hidden rounded-top">
                <img
                  src={agent.image}
                  alt={agent.name}
                  className="card-img-top"
                  style={{ height: "330px", objectFit: "cover" }}
                />
              </div>


              {/* Social Media Icons */}
              <motion.div
                className=" position-absolute top-50 start-0 translate-middle-y col-1"
                initial={{ opacity: 0, x: -50 }} // Start off-screen and invisible
                animate={{ opacity: hoveredCard === index ? 1 : 0, x: hoveredCard === index ? 0 : -50 }} // Only show when hovered
                transition={{ duration: 0.5 }} // Smooth transition
              >
                <a href="/wrwe" className="social-icon text-white fs-4 mx-2 mb-3 p-2" title="Facebook">
                  <FaFacebook className="text-success" />
                </a>
                <a href="/erwqwe" className="social-icon text-white fs-4 mx-2 mb-3 p-2" title="Twitter">
                  <FaTwitter className="text-success" />
                </a>
                <a href="/ewrw" className="social-icon text-white fs-4 mx-2 mb-3 p-2" title="Instagram">
                  <FaInstagram className="text-success" />
                </a>
                <a href="/reter" className="social-icon text-white fs-4 mx-2 mb-3 p-2" title="LinkedIn">
                  <FaLinkedin className="text-success" />
                </a>
              </motion.div>

              <div className="card-body text-center">
                <h5 className="card-title">{agent.name}</h5>
                <p className="card-text text-muted">{agent.phone}</p>
                <p className="card-text text-muted">{agent.email}</p>
                <p className="card-text text-primary">
                  {agent.properties} Properties
                </p>
              </div>
            </motion.div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
